import { SeriesRegistrationPageSkeleton } from "./SeriesRegistrationPageSkeleton";
import { Button } from "@mui/material";
import { Link, Redirect, useParams } from "react-router-dom";
import { useOrganisation } from "../../../../../providers/OrganisationProvider";
import { NotifiedRedirect } from "../../../../../routing/NotifiedRedirect";
import { SeriesRegistrationWrapper } from "./SeriesRegistrationWrapper";
import { EmptyState } from "../../../../../layout/EmptyState";
import { Closed } from "../../../../../../styleguide/icons/icons";
import { RegistrationPageHeader } from "../../../../../layout/registration/RegistrationPageHeader";
import { useCanAcceptPayments } from "hooks/useCanAcceptPayments";
import { CloudOff } from "@mui/icons-material";
import { T } from "components/util/t";

const SeriesRegistration = ({ organisation, series }) => {
    const canAcceptPayments = useCanAcceptPayments(series.options, series.organisation.shortName);

    return (
        <>
            <RegistrationPageHeader
                crumbs={[{ text: organisation?.name, link: `/${organisation?.shortName}` }]}
                current={series?.name}
                title="Member registration"
            />
            {canAcceptPayments
                ? series.signOnStatus === "open" ?
                    <SeriesRegistrationWrapper organisation={organisation} series={series}/> :
                    <EmptyState
                        icon={<Closed/>}
                        text="You're a little late! Membership registration has been closed by the organiser."
                        action={
                            <Button variant="contained" component={Link} to={`/${organisation.shortName}`}>
                                {organisation.name}
                            </Button>
                        }
                    />
                : <EmptyState icon={<CloudOff />} text={<T organisation={series.organisation}>registration_unavailable</T>} />}
        </>
    );
};

const SeriesRegistrationPage = () => {
    const { seriesId } = useParams();
    const organisation = useOrganisation();

    if (!organisation) return <SeriesRegistrationPageSkeleton/>;

    const series = organisation?.series.find(s => s.id === seriesId);
    if (!series) return <NotifiedRedirect to={`/${organisation.shortName}`} message="It looks like we can't find what you are looking for!"/>;

    const isFederatedMembership = !!series.options?.federatedMembership;

    if (isFederatedMembership) return <Redirect to={`/${organisation.shortName}/memberships`}/>;

    return <SeriesRegistration organisation={organisation} series={series}/>;
};

export default SeriesRegistrationPage;
